/*
  This file is semi-automatically generated from
  cliq/taxonomy/scripts/generate_anzsic_rev2__ceda_5_weighted_mapping.py in the cliq repo
  Do not manually modify this file
 */

import type { WeightedBeaCodes } from './industryCodeUtils';

export const ANZSIC_CODES: {
  [key: string]: {
    label: string;
    BEA_CODES: WeightedBeaCodes;
  };
} = {
  ['0111']: {
    label: 'Nursery Production (Under Cover)',
    BEA_CODES: { '111400': 1.0 },
  },
  ['0112']: {
    label: 'Nursery Production (Outdoors)',
    BEA_CODES: { '111400': 1.0 },
  },
  ['0113']: { label: 'Turf Growing', BEA_CODES: { '111400': 1.0 } },
  ['0114']: {
    label: 'Floriculture Production (Under Cover)',
    BEA_CODES: { '111400': 1.0 },
  },
  ['0115']: {
    label: 'Floriculture Production (Outdoors)',
    BEA_CODES: { '111400': 1.0 },
  },
  ['0121']: { label: 'Mushroom Growing', BEA_CODES: { '111400': 1.0 } },
  ['0122']: {
    label: 'Vegetable Growing (Under Cover)',
    BEA_CODES: { '111400': 1.0 },
  },
  ['0123']: {
    label: 'Vegetable Growing (Outdoors)',
    BEA_CODES: { '111200': 1.0 },
  },
  ['0131']: { label: 'Grape Growing', BEA_CODES: { '111300': 1.0 } },
  ['0132']: { label: 'Kiwifruit Growing', BEA_CODES: { '111300': 1.0 } },
  ['0133']: { label: 'Berry Fruit Growing', BEA_CODES: { '111300': 1.0 } },
  ['0134']: { label: 'Apple and Pear Growing', BEA_CODES: { '111300': 1.0 } },
  ['0135']: { label: 'Stone Fruit Growing', BEA_CODES: { '111300': 1.0 } },
  ['0136']: { label: 'Citrus Fruit Growing', BEA_CODES: { '111300': 1.0 } },
  ['0137']: { label: 'Olive Growing', BEA_CODES: { '111300': 1.0 } },
  ['0139']: {
    label: 'Other Fruit and Tree Nut Growing',
    BEA_CODES: { '111300': 1.0 },
  },
  ['0141']: {
    label: 'Sheep Farming (Specialised)',
    BEA_CODES: { '112A00': 1.0 },
  },
  ['0142']: {
    label: 'Beef Cattle Farming (Specialised)',
    BEA_CODES: { '1121A0': 1.0 },
  },
  ['0143']: {
    label: 'Beef Cattle Feedlots (Specialised)',
    BEA_CODES: { '1121A0': 1.0 },
  },
  ['0144']: {
    label: 'Sheep-Beef Cattle Farming',
    BEA_CODES: { '1121A0': 0.72458424, '112A00': 0.27541576 },
  },
  ['0145']: {
    label: 'Grain-Sheep or Grain-Beef Cattle Farming',
    BEA_CODES: { '112A00': 1.0 },
  },
  ['0146']: { label: 'Rice Growing', BEA_CODES: { '1111B0': 1.0 } },
  ['0149']: {
    label: 'Other Grain Growing',
    BEA_CODES: { '1111A0': 0.39841985, '1111B0': 0.60158015 },
  },
  ['0151']: { label: 'Sugar Cane Growing', BEA_CODES: { '111900': 1.0 } },
  ['0152']: { label: 'Cotton Growing', BEA_CODES: { '111900': 1.0 } },
  ['0159']: {
    label: 'Other Crop Growing n.e.c.',
    BEA_CODES: { '111900': 1.0 },
  },
  ['0160']: { label: 'Dairy Cattle Farming', BEA_CODES: { '112120': 1.0 } },
  ['0171']: { label: 'Poultry Farming (Meat)', BEA_CODES: { '112300': 1.0 } },
  ['0172']: { label: 'Poultry Farming (Eggs)', BEA_CODES: { '112300': 1.0 } },
  ['0180']: { label: 'Deer Farming', BEA_CODES: { '112A00': 1.0 } },
  ['0191']: { label: 'Horse Farming', BEA_CODES: { '112A00': 1.0 } },
  ['0192']: { label: 'Pig Farming', BEA_CODES: { '112A00': 1.0 } },
  ['0193']: { label: 'Beekeeping', BEA_CODES: { '112A00': 1.0 } },
  ['0199']: {
    label: 'Other Livestock Farming n.e.c.',
    BEA_CODES: { '112A00': 1.0 },
  },
  ['0201']: {
    label: 'Offshore Longline and Rack Aquaculture',
    BEA_CODES: { '112A00': 1.0 },
  },
  ['0202']: {
    label: 'Offshore Caged Aquaculture',
    BEA_CODES: { '112A00': 1.0 },
  },
  ['0203']: { label: 'Onshore Aquaculture', BEA_CODES: { '112A00': 1.0 } },
  ['0301']: { label: 'Forestry', BEA_CODES: { '113000': 1.0 } },
  ['0302']: { label: 'Logging', BEA_CODES: { '113000': 1.0 } },
  ['0411']: {
    label: 'Rock Lobster and Crab Potting',
    BEA_CODES: { '114000': 1.0 },
  },
  ['0412']: { label: 'Prawn Fishing', BEA_CODES: { '114000': 1.0 } },
  ['0413']: { label: 'Line Fishing', BEA_CODES: { '114000': 1.0 } },
  ['0414']: {
    label: 'Fish Trawling, Seining and Netting',
    BEA_CODES: { '114000': 1.0 },
  },
  ['0419']: { label: 'Other Fishing', BEA_CODES: { '114000': 1.0 } },
  ['0420']: { label: 'Hunting and Trapping', BEA_CODES: { '114000': 1.0 } },
  ['0510']: {
    label: 'Forestry Support Services',
    BEA_CODES: { '113000': 1.0 },
  },
  ['0521']: { label: 'Cotton Ginning', BEA_CODES: { '115000': 1.0 } },
  ['0522']: { label: 'Shearing Services', BEA_CODES: { '115000': 1.0 } },
  ['0529']: {
    label: 'Other Agriculture and Fishing Support Services',
    BEA_CODES: { '115000': 1.0 },
  },
  ['0600']: { label: 'Coal Mining', BEA_CODES: { '212100': 1.0 } },
  ['0700']: { label: 'Oil and Gas Extraction', BEA_CODES: { '211000': 1.0 } },
  ['0801']: { label: 'Iron Ore Mining', BEA_CODES: { '2122A0': 1.0 } },
  ['0802']: { label: 'Bauxite Mining', BEA_CODES: { '2122A0': 1.0 } },
  ['0803']: { label: 'Copper Ore Mining', BEA_CODES: { '212230': 1.0 } },
  ['0804']: { label: 'Gold Ore Mining', BEA_CODES: { '2122A0': 1.0 } },
  ['0805']: { label: 'Mineral Sand Mining', BEA_CODES: { '212230': 1.0 } },
  ['0806']: { label: 'Nickel Ore Mining', BEA_CODES: { '212230': 1.0 } },
  ['0807']: {
    label: 'Silver-Lead-Zinc Ore Mining',
    BEA_CODES: { '212230': 1.0 },
  },
  ['0809']: { label: 'Other Metal Ore Mining', BEA_CODES: { '2122A0': 1.0 } },
  ['0911']: {
    label: 'Gravel and Sand Quarrying',
    BEA_CODES: { '2123A0': 1.0 },
  },
  ['0919']: {
    label: 'Other Construction Material Mining',
    BEA_CODES: { '2123A0': 1.0 },
  },
  ['0990']: {
    label: 'Other Non-Metallic Mineral Mining and Quarrying',
    BEA_CODES: { '2123A0': 1.0 },
  },
  ['1011']: { label: 'Petroleum Exploration', BEA_CODES: { '211000': 1.0 } },
  ['1012']: { label: 'Mineral Exploration', BEA_CODES: { '21311A': 1.0 } },
  ['1090']: {
    label: 'Other Mining Support Services',
    BEA_CODES: { '21311A': 1.0 },
  },
  ['1111']: { label: 'Meat Processing', BEA_CODES: { '31161A': 1.0 } },
  ['1112']: { label: 'Poultry Processing', BEA_CODES: { '311615': 1.0 } },
  ['1113']: {
    label: 'Cured Meat and Smallgoods Manufacturing',
    BEA_CODES: { '31161A': 1.0 },
  },
  ['1120']: { label: 'Seafood Processing', BEA_CODES: { '311700': 1.0 } },
  ['1131']: {
    label: 'Milk and Cream Processing',
    BEA_CODES: { '31151A': 1.0 },
  },
  ['1132']: { label: 'Ice Cream Manufacturing', BEA_CODES: { '311520': 1.0 } },
  ['1133']: {
    label: 'Cheese and Other Dairy Product Manufacturing',
    BEA_CODES: { '311513': 1.0 },
  },
  ['1140']: {
    label: 'Fruit and Vegetable Processing',
    BEA_CODES: { '311420': 1.0 },
  },
  ['1150']: {
    label: 'Oil and Fat Manufacturing',
    BEA_CODES: { '311224': 0.7523717, '311225': 0.2476283 },
  },
  ['1161']: {
    label: 'Grain Mill Product Manufacturing',
    BEA_CODES: { '311210': 1.0 },
  },
  ['1162']: {
    label: 'Cereal, Pasta and Baking Mix Manufacturing',
    BEA_CODES: { '311230': 0.28700051, '3118A0': 0.71299949 },
  },
  ['1171']: {
    label: 'Bread Manufacturing (Factory based)',
    BEA_CODES: { '311810': 1.0 },
  },
  ['1172']: {
    label: 'Cake and Pastry Manufacturing (Factory based)',
    BEA_CODES: { '311810': 1.0 },
  },
  ['1173']: {
    label: 'Biscuit Manufacturing (Factory based)',
    BEA_CODES: { '3118A0': 1.0 },
  },
  ['1174']: {
    label: 'Bakery Product Manufacturing (Non-factory based)',
    BEA_CODES: { '311810': 1.0 },
  },
  ['1181']: { label: 'Sugar Manufacturing', BEA_CODES: { '311300': 1.0 } },
  ['1182']: {
    label: 'Confectionery Manufacturing',
    BEA_CODES: { '311300': 1.0 },
  },
  ['1191']: {
    label: 'Potato, Corn and Other Crisp Manufacturing',
    BEA_CODES: { '311910': 1.0 },
  },
  ['1192']: {
    label: 'Prepared Animal and Bird Feed Manufacturing',
    BEA_CODES: { '311111': 0.42849454, '311119': 0.57150546 },
  },
  ['1199']: {
    label: 'Other Food Product Manufacturing n.e.c.',
    BEA_CODES: { '311990': 1.0 },
  },
  ['1211']: {
    label: 'Soft Drink, Cordial and Syrup Manufacturing',
    BEA_CODES: {
      '311930': 0.15492661,
      '312110': 0.5940081,
      '312140': 0.25106528,
    },
  },
  ['1212']: { label: 'Beer Manufacturing', BEA_CODES: { '312120': 1.0 } },
  ['1213']: { label: 'Spirit Manufacturing', BEA_CODES: { '312140': 1.0 } },
  ['1214']: {
    label: 'Wine and Other Alcoholic Beverage Manufacturing',
    BEA_CODES: { '312130': 1.0 },
  },
  ['1220']: {
    label: 'Cigarette and Tobacco Product Manufacturing',
    BEA_CODES: { '312200': 1.0 },
  },
  ['1311']: { label: 'Wool Scouring', BEA_CODES: { '313300': 1.0 } },
  ['1312']: {
    label: 'Natural Textile Manufacturing',
    BEA_CODES: { '313100': 1.0 },
  },
  ['1313']: {
    label: 'Synthetic Textile Manufacturing',
    BEA_CODES: { '313100': 1.0 },
  },
  ['1320']: {
    label: 'Leather Tanning, Fur Dressing and Leather Product Manufacturing',
    BEA_CODES: { '316000': 1.0 },
  },
  ['1331']: {
    label: 'Textile Floor Covering Manufacturing',
    BEA_CODES: { '314110': 1.0 },
  },
  ['1332']: {
    label: 'Rope, Cordage and Twine Manufacturing',
    BEA_CODES: { '314900': 1.0 },
  },
  ['1333']: {
    label: 'Cut and Sewn Textile Product Manufacturing',
    BEA_CODES: { '314120': 0.28565211, '314900': 0.71434789 },
  },
  ['1334']: {
    label: 'Textile Finishing and Other Textile Product Manufacturing',
    BEA_CODES: { '313300': 0.46498615, '314900': 0.53501385 },
  },
  ['1340']: {
    label: 'Knitted Product Manufacturing',
    BEA_CODES: { '313200': 1.0 },
  },
  ['1351']: { label: 'Clothing Manufacturing', BEA_CODES: { '315000': 1.0 } },
  ['1352']: { label: 'Footwear Manufacturing', BEA_CODES: { '316000': 1.0 } },
  ['1411']: { label: 'Log Sawmilling', BEA_CODES: { '321100': 1.0 } },
  ['1412']: {
    label: 'Wood Chipping',
    BEA_CODES: { '321100': 0.58776504, '3219A0': 0.41223496 },
  },
  ['1413']: {
    label: 'Timber Resawing and Dressing',
    BEA_CODES: { '321100': 1.0 },
  },
  ['1491']: {
    label: 'Prefabricated Wooden Building Manufacturing',
    BEA_CODES: { '3219A0': 1.0 },
  },
  ['1492']: {
    label: 'Wooden Structural Fitting and Component Manufacturing',
    BEA_CODES: { '321910': 1.0 },
  },
  ['1493']: {
    label: 'Veneer and Plywood Manufacturing',
    BEA_CODES: { '321200': 1.0 },
  },
  ['1494']: {
    label: 'Reconstituted Wood Product Manufacturing',
    BEA_CODES: { '321200': 1.0 },
  },
  ['1499']: {
    label: 'Other Wood Product Manufacturing n.e.c.',
    BEA_CODES: { '3219A0': 1.0 },
  },
  ['1510']: {
    label: 'Pulp, Paper and Paperboard Manufacturing',
    BEA_CODES: {
      '322110': 0.09767375,
      '322120': 0.47891135,
      '322130': 0.4234149,
    },
  },
  ['1521']: {
    label: 'Corrugated Paperboard and Paperboard Container Manufacturing',
    BEA_CODES: { '322210': 1.0 },
  },
  ['1522']: { label: 'Paper Bag Manufacturing', BEA_CODES: { '322220': 1.0 } },
  ['1523']: {
    label: 'Paper Stationery Manufacturing',
    BEA_CODES: { '322230': 1.0 },
  },
  ['1524']: {
    label: 'Sanitary Paper Product Manufacturing',
    BEA_CODES: { '322291': 1.0 },
  },
  ['1529']: {
    label: 'Other Converted Paper Product Manufacturing',
    BEA_CODES: { '322299': 1.0 },
  },
  ['1611']: { label: 'Printing', BEA_CODES: { '323110': 1.0 } },
  ['1612']: {
    label: 'Printing Support Services',
    BEA_CODES: { '323120': 1.0 },
  },
  ['1620']: {
    label: 'Reproduction of Recorded Media',
    BEA_CODES: { '334610': 1.0 },
  },
  ['1701']: {
    label: 'Petroleum Refining and Petroleum Fuel Manufacturing',
    BEA_CODES: { '324110': 0.9449562, '324190': 0.0550438 },
  },
  ['1709']: {
    label: 'Other Petroleum and Coal Product Manufacturing',
    BEA_CODES: { '324190': 1.0 },
  },
  ['1811']: {
    label: 'Industrial Gas Manufacturing',
    BEA_CODES: { '325120': 1.0 },
  },
  ['1812']: {
    label: 'Basic Organic Chemical Manufacturing',
    BEA_CODES: { '325190': 1.0 },
  },
  ['1813']: {
    label: 'Basic Inorganic Chemical Manufacturing',
    BEA_CODES: { '325180': 1.0 },
  },
  ['1821']: {
    label: 'Synthetic Resin and Synthetic Rubber Manufacturing',
    BEA_CODES: { '325211': 0.81655691, '3252A0': 0.18344309 },
  },
  ['1829']: {
    label: 'Other Basic Polymer Manufacturing',
    BEA_CODES: { '325211': 1.0 },
  },
  ['1831']: { label: 'Fertiliser Manufacturing', BEA_CODES: { '325310': 1.0 } },
  ['1832']: { label: 'Pesticide Manufacturing', BEA_CODES: { '325320': 1.0 } },
  ['1841']: {
    label: 'Human Pharmaceutical and Medicinal Product Manufacturing',
    BEA_CODES: {
      '325411': 0.0572358,
      '325412': 0.78197769,
      '325414': 0.16078651,
    },
  },
  ['1842']: {
    label: 'Veterinary Pharmaceutical and Medicinal Product Manufacturing',
    BEA_CODES: { '325412': 0.82945204, '325414': 0.17054796 },
  },
  ['1851']: {
    label: 'Cleaning Compound Manufacturing',
    BEA_CODES: { '325610': 1.0 },
  },
  ['1852']: {
    label: 'Cosmetic and Toiletry Preparation Manufacturing',
    BEA_CODES: { '325620': 1.0 },
  },
  ['1891']: {
    label: 'Photographic Chemical Product Manufacturing',
    BEA_CODES: { '325130': 0.14025248, '3259A0': 0.85974752 },
  },
  ['1892']: { label: 'Explosive Manufacturing', BEA_CODES: { '3259A0': 1.0 } },
  ['1899']: {
    label: 'Other Basic Chemical Product Manufacturing n.e.c.',
    BEA_CODES: { '3259A0': 1.0 },
  },
  ['1911']: {
    label: 'Polymer Film and Sheet Packaging Material Manufacturing',
    BEA_CODES: { '326110': 1.0 },
  },
  ['1912']: {
    label: 'Rigid and Semi-Rigid Polymer Product Manufacturing',
    BEA_CODES: { '326120': 0.15303985, '326190': 0.84696015 },
  },
  ['1913']: {
    label: 'Polymer Foam Product Manufacturing',
    BEA_CODES: { '326150': 1.0 },
  },
  ['1914']: { label: 'Tyre Manufacturing', BEA_CODES: { '326210': 1.0 } },
  ['1915']: { label: 'Adhesive Manufacturing', BEA_CODES: { '325520': 1.0 } },
  ['1916']: {
    label: 'Paint and Coatings Manufacturing',
    BEA_CODES: { '325510': 1.0 },
  },
  ['1919']: {
    label: 'Other Polymer Product Manufacturing',
    BEA_CODES: { '339990': 1.0 },
  },
  ['1920']: {
    label: 'Natural Rubber Product Manufacturing',
    BEA_CODES: { '326220': 0.254811, '326290': 0.745189 },
  },
  ['2010']: {
    label: 'Glass and Glass Product Manufacturing',
    BEA_CODES: { '327200': 1.0 },
  },
  ['2021']: { label: 'Clay Brick Manufacturing', BEA_CODES: { '327100': 1.0 } },
  ['2029']: {
    label: 'Other Ceramic Product Manufacturing',
    BEA_CODES: { '327100': 1.0 },
  },
  ['2031']: {
    label: 'Cement and Lime Manufacturing',
    BEA_CODES: { '327310': 0.50009295, '327400': 0.49990705 },
  },
  ['2032']: {
    label: 'Plaster Product Manufacturing',
    BEA_CODES: { '327400': 1.0 },
  },
  ['2033']: {
    label: 'Ready-Mixed Concrete Manufacturing',
    BEA_CODES: { '327320': 1.0 },
  },
  ['2034']: {
    label: 'Concrete Product Manufacturing',
    BEA_CODES: { '327330': 0.32841845, '327390': 0.67158155 },
  },
  ['2090']: {
    label: 'Other Non-Metallic Mineral Product Manufacturing',
    BEA_CODES: { '327999': 1.0 },
  },
  ['2110']: {
    label: 'Iron Smelting and Steel Manufacturing',
    BEA_CODES: { '331110': 0.91685024, '331200': 0.08314976 },
  },
  ['2121']: { label: 'Iron and Steel Casting', BEA_CODES: { '331110': 1.0 } },
  ['2122']: {
    label: 'Steel Pipe and Tube Manufacturing',
    BEA_CODES: { '331200': 0.64702783, '332996': 0.35297217 },
  },
  ['2131']: { label: 'Alumina Production', BEA_CODES: { '331313': 1.0 } },
  ['2132']: { label: 'Aluminium Smelting', BEA_CODES: { '331313': 1.0 } },
  ['2133']: {
    label: 'Copper, Silver, Lead and Zinc Smelting and Refining',
    BEA_CODES: { '331410': 1.0 },
  },
  ['2139']: {
    label: 'Other Basic Non-Ferrous Metal Manufacturing',
    BEA_CODES: { '331410': 0.59432259, '331490': 0.40567741 },
  },
  ['2141']: {
    label: 'Non-Ferrous Metal Casting',
    BEA_CODES: { '331520': 1.0 },
  },
  ['2142']: {
    label: 'Aluminium Rolling, Drawing, Extruding',
    BEA_CODES: { '33131B': 1.0 },
  },
  ['2149']: {
    label: 'Other Basic Non-Ferrous Metal Product Manufacturing',
    BEA_CODES: { '331410': 0.59432259, '331490': 0.40567741 },
  },
  ['2210']: { label: 'Iron and Steel Forging', BEA_CODES: { '33211A': 1.0 } },
  ['2221']: {
    label: 'Structural Steel Fabricating',
    BEA_CODES: { '332310': 1.0 },
  },
  ['2222']: {
    label: 'Prefabricated Metal Building Manufacturing',
    BEA_CODES: { '332310': 1.0 },
  },
  ['2223']: {
    label: 'Architectural Aluminium Product Manufacturing',
    BEA_CODES: { '332320': 1.0 },
  },
  ['2224']: {
    label: 'Metal Roof and Guttering Manufacturing (except Aluminium)',
    BEA_CODES: { '332310': 1.0 },
  },
  ['2229']: {
    label: 'Other Structural Metal Product Manufacturing',
    BEA_CODES: { '332310': 1.0 },
  },
  ['2231']: {
    label: 'Boiler, Tank and Other Heavy Gauge Metal Container Manufacturing',
    BEA_CODES: { '332420': 1.0 },
  },
  ['2239']: {
    label: 'Other Metal Container Manufacturing',
    BEA_CODES: { '332430': 0.55852078, '332999': 0.44147922 },
  },
  ['2240']: {
    label:
      'Sheet Metal Product Manufacturing (except Metal Structural and Container Products)',
    BEA_CODES: { '332320': 1.0 },
  },
  ['2291']: {
    label: 'Spring and Wire Product Manufacturing',
    BEA_CODES: { '332600': 1.0 },
  },
  ['2292']: {
    label: 'Nut, Bolt, Screw and Rivet Manufacturing',
    BEA_CODES: { '332720': 1.0 },
  },
  ['2293']: {
    label: 'Metal Coating and Finishing',
    BEA_CODES: { '332800': 1.0 },
  },
  ['2299']: {
    label: 'Other Fabricated Metal Product Manufacturing n.e.c.',
    BEA_CODES: {
      '332200': 0.09693601,
      '332320': 0.458403,
      '332500': 0.09663703,
      '332913': 0.04949782,
      '332999': 0.15387511,
      '33299A': 0.14465102,
    },
  },
  ['2311']: {
    label: 'Motor Vehicle Manufacturing',
    BEA_CODES: {
      '336111': 0.11809398,
      '336112': 0.77605698,
      '336120': 0.10584904,
    },
  },
  ['2312']: {
    label: 'Motor Vehicle Body and Trailer Manufacturing',
    BEA_CODES: {
      '336211': 0.28267274,
      '336212': 0.28406535,
      '336214': 0.43326192,
    },
  },
  ['2313']: {
    label: 'Automotive Electrical Component Manufacturing',
    BEA_CODES: { '336320': 1.0 },
  },
  ['2319']: {
    label: 'Other Motor Vehicle Parts Manufacturing',
    BEA_CODES: { '336390': 1.0 },
  },
  ['2391']: {
    label: 'Shipbuilding and Repair Services',
    BEA_CODES: { '336611': 1.0 },
  },
  ['2392']: {
    label: 'Boatbuilding and Repair Services',
    BEA_CODES: { '336612': 1.0 },
  },
  ['2393']: {
    label: 'Railway Rolling Stock Manufacturing and Repair Services',
    BEA_CODES: { '336500': 1.0 },
  },
  ['2394']: {
    label: 'Aircraft Manufacturing and Repair Services',
    BEA_CODES: {
      '336411': 0.6158663,
      '336412': 0.19804332,
      '336413': 0.18609038,
    },
  },
  ['2399']: {
    label: 'Other Transport Equipment Manufacturing n.e.c.',
    BEA_CODES: { '336999': 1.0 },
  },
  ['2411']: {
    label: 'Photographic, Optical and Ophthalmic Equipment Manufacturing',
    BEA_CODES: { '333314': 0.79417408, '333316': 0.20582592 },
  },
  ['2412']: {
    label: 'Medical and Surgical Equipment Manufacturing',
    BEA_CODES: { '339112': 0.57592023, '339113': 0.42407977 },
  },
  ['2419']: {
    label: 'Other Professional and Scientific Equipment Manufacturing',
    BEA_CODES: {
      '334511': 0.50411011,
      '334513': 0.10442923,
      '334515': 0.11338665,
      '334516': 0.15688116,
      '33451A': 0.12119284,
    },
  },
  ['2421']: {
    label: 'Computer and Electronic Office Equipment Manufacturing',
    BEA_CODES: {
      '334111': 0.40085529,
      '334112': 0.2024184,
      '334118': 0.39672631,
    },
  },
  ['2422']: {
    label: 'Communication Equipment Manufacturing',
    BEA_CODES: { '334220': 0.84878656, '334290': 0.15121344 },
  },
  ['2429']: {
    label: 'Other Electronic Equipment Manufacturing',
    BEA_CODES: { '33441A': 1.0 },
  },
  ['2431']: {
    label: 'Electric Cable and Wire Manufacturing',
    BEA_CODES: { '335920': 1.0 },
  },
  ['2432']: {
    label: 'Electric Lighting Equipment Manufacturing',
    BEA_CODES: { '335120': 1.0 },
  },
  ['2439']: {
    label: 'Other Electrical Equipment Manufacturing',
    BEA_CODES: { '334418': 1.0 },
  },
  ['2441']: {
    label: 'Whiteware Appliance Manufacturing',
    BEA_CODES: {
      '335221': 0.25184741,
      '335222': 0.21424822,
      '335224': 0.21441409,
      '335228': 0.31949027,
    },
  },
  ['2449']: {
    label: 'Other Domestic Appliance Manufacturing',
    BEA_CODES: { '33399A': 0.89147191, '334512': 0.10852809 },
  },
  ['2451']: {
    label: 'Pump and Compressor Manufacturing',
    BEA_CODES: { '33391A': 1.0 },
  },
  ['2452']: {
    label:
      'Fixed Space Heating, Cooling and Ventilation Equipment Manufacturing',
    BEA_CODES: { '334512': 1.0 },
  },
  ['2461']: {
    label: 'Agricultural Machinery and Equipment Manufacturing',
    BEA_CODES: { '333111': 0.76961441, '333112': 0.23038559 },
  },
  ['2462']: {
    label: 'Mining and Construction Machinery Manufacturing',
    BEA_CODES: { '333120': 0.65428397, '333130': 0.34571603 },
  },
  ['2463']: {
    label: 'Machine Tool and Parts Manufacturing',
    BEA_CODES: { '333517': 1.0 },
  },
  ['2469']: {
    label: 'Other Specialised Machinery and Equipment Manufacturing',
    BEA_CODES: { '333517': 1.0 },
  },
  ['2491']: {
    label: 'Lifting and Material Handling Equipment Manufacturing',
    BEA_CODES: { '333920': 1.0 },
  },
  ['2499']: {
    label: 'Other Machinery and Equipment Manufacturing n.e.c.',
    BEA_CODES: { '33399A': 1.0 },
  },
  ['2511']: {
    label: 'Wooden Furniture and Upholstered Seat Manufacturing',
    BEA_CODES: { '337110': 0.54937636, '337121': 0.45062364 },
  },
  ['2512']: {
    label: 'Metal Furniture Manufacturing',
    BEA_CODES: { '337900': 1.0 },
  },
  ['2513']: { label: 'Mattress Manufacturing', BEA_CODES: { '337900': 1.0 } },
  ['2519']: {
    label: 'Other Furniture Manufacturing',
    BEA_CODES: { '337900': 1.0 },
  },
  ['2591']: {
    label: 'Jewellery and Silverware Manufacturing',
    BEA_CODES: { '339910': 1.0 },
  },
  ['2592']: {
    label: 'Toy, Sporting and Recreational Product Manufacturing',
    BEA_CODES: { '339920': 0.81387108, '339930': 0.18612892 },
  },
  ['2599']: {
    label: 'Other Manufacturing n.e.c.',
    BEA_CODES: { '339990': 1.0 },
  },
  ['2611']: {
    label: 'Fossil Fuel Electricity Generation',
    BEA_CODES: {
      '22111A': 0.55847953,
      '22111B': 0.43274854,
      '22111C': 0.00877193,
    },
  },
  ['2612']: {
    label: 'Hydro-Electricity Generation',
    BEA_CODES: { '221111': 1.0 },
  },
  ['2619']: {
    label: 'Other Electricity Generation',
    BEA_CODES: {
      '221113': 0.76923077,
      '221114': 0.00641026,
      '221115': 0.13461538,
      '221116': 0.01282051,
      '221117': 0.07051282,
      '221118': 0.00641026,
    },
  },
  ['2620']: { label: 'Electricity Transmission', BEA_CODES: { '221121': 1.0 } },
  ['2630']: { label: 'Electricity Distribution', BEA_CODES: { '221122': 1.0 } },
  ['2640']: {
    label: 'On Selling Electricity and Electricity Market Operation',
    BEA_CODES: { '221122': 1.0 },
  },
  ['2700']: { label: 'Gas Supply', BEA_CODES: { '221200': 1.0 } },
  ['2811']: { label: 'Water Supply', BEA_CODES: { '221300': 1.0 } },
  ['2812']: {
    label: 'Sewerage and Drainage Services',
    BEA_CODES: { '221300': 1.0 },
  },
  ['2911']: {
    label: 'Solid Waste Collection Services',
    BEA_CODES: { '562111': 1.0 },
  },
  ['2919']: {
    label: 'Other Waste Collection Services',
    BEA_CODES: { '562OTH': 1.0 },
  },
  ['2921']: {
    label: 'Waste Treatment and Disposal Services',
    BEA_CODES: { '562213': 0.5, '562920': 0.5 },
  },
  ['2922']: {
    label: 'Waste Remediation and Materials Recovery Services',
    BEA_CODES: { '562910': 1.0 },
  },
  ['3011']: { label: 'House Construction', BEA_CODES: { '233411': 1.0 } },
  ['3019']: {
    label: 'Other Residential Building Construction',
    BEA_CODES: { '233412': 1.0 },
  },
  ['3020']: {
    label: 'Non-Residential Building Construction',
    BEA_CODES: {
      '230301': 0.3448597,
      '233210': 0.07949412,
      '233230': 0.11921334,
      '233262': 0.17068723,
      '2332A0': 0.28574561,
    },
  },
  ['3101']: {
    label: 'Road and Bridge Construction',
    BEA_CODES: { '2332C0': 1.0 },
  },
  ['3109']: {
    label: 'Other Heavy and Civil Engineering Construction',
    BEA_CODES: { '2332D0': 1.0 },
  },
  ['3211']: {
    label: 'Land Development and Subdivision',
    BEA_CODES: { '2332D0': 0.32811813, '2334A0': 0.67188187 },
  },
  ['3212']: {
    label: 'Site Preparation Services',
    BEA_CODES: { '2332D0': 0.32811813, '2334A0': 0.67188187 },
  },
  ['3221']: {
    label: 'Concreting Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3222']: {
    label: 'Bricklaying Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3223']: {
    label: 'Roofing Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3224']: {
    label: 'Structural Steel Erection Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3231']: {
    label: 'Plumbing Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3232']: {
    label: 'Electrical Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3233']: {
    label: 'Air Conditioning and Heating Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3234']: {
    label: 'Fire and Security Alarm Installation Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3239']: {
    label: 'Other Building Installation Services',
    BEA_CODES: { '230301': 0.62394472, '2332D0': 0.37605528 },
  },
  ['3241']: {
    label: 'Plastering and Ceiling Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3242']: {
    label: 'Carpentry Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3243']: {
    label: 'Tiling and Carpeting Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3244']: {
    label: 'Painting and Decorating Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3245']: {
    label: 'Glazing Services',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3291']: {
    label: 'Landscape Construction Services',
    BEA_CODES: { '2332D0': 0.32811813, '2334A0': 0.67188187 },
  },
  ['3292']: {
    label: 'Hire of Construction Machinery with Operator',
    BEA_CODES: { '532400': 1.0 },
  },
  ['3299']: {
    label: 'Other Construction Services n.e.c.',
    BEA_CODES: { '230301': 0.70761797, '230302': 0.29238203 },
  },
  ['3311']: { label: 'Wool Wholesaling', BEA_CODES: { '424A00': 1.0 } },
  ['3312']: { label: 'Cereal Grain Wholesaling', BEA_CODES: { '424400': 1.0 } },
  ['3319']: {
    label: 'Other Agricultural Product Wholesaling',
    BEA_CODES: { '424A00': 1.0 },
  },
  ['3321']: {
    label: 'Petroleum Product Wholesaling',
    BEA_CODES: { '424700': 1.0 },
  },
  ['3322']: {
    label: 'Metal and Mineral Wholesaling',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['3323']: {
    label: 'Industrial and Agricultural Chemical Product Wholesaling',
    BEA_CODES: { '424A00': 1.0 },
  },
  ['3331']: { label: 'Timber Wholesaling', BEA_CODES: { '423A00': 1.0 } },
  ['3332']: {
    label: 'Plumbing Goods Wholesaling',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['3339']: {
    label: 'Other Hardware Goods Wholesaling',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['3411']: {
    label: 'Agricultural and Construction Machinery Wholesaling',
    BEA_CODES: { '423800': 1.0 },
  },
  ['3419']: {
    label: 'Other Specialised Industrial Machinery and Equipment Wholesaling',
    BEA_CODES: { '423800': 1.0 },
  },
  ['3491']: {
    label: 'Professional and Scientific Goods Wholesaling',
    BEA_CODES: { '423400': 1.0 },
  },
  ['3492']: {
    label: 'Computer and Computer Peripheral Wholesaling',
    BEA_CODES: { '423400': 0.48199156, '423600': 0.51800844 },
  },
  ['3493']: {
    label: 'Telecommunication Goods Wholesaling',
    BEA_CODES: { '423600': 1.0 },
  },
  ['3494']: {
    label: 'Other Electrical and Electronic Goods Wholesaling',
    BEA_CODES: { '423600': 1.0 },
  },
  ['3499']: {
    label: 'Other Machinery and Equipment Wholesaling n.e.c.',
    BEA_CODES: { '423800': 1.0 },
  },
  ['3501']: { label: 'Car Wholesaling', BEA_CODES: { '423100': 1.0 } },
  ['3502']: {
    label: 'Commercial Vehicle Wholesaling',
    BEA_CODES: { '423100': 1.0 },
  },
  ['3503']: {
    label: 'Trailer and Other Motor Vehicle Wholesaling',
    BEA_CODES: { '423100': 1.0 },
  },
  ['3504']: {
    label: 'Motor Vehicle New Parts Wholesaling',
    BEA_CODES: { '423100': 1.0 },
  },
  ['3505']: {
    label: 'Motor Vehicle Dismantling and Used Parts Wholesaling',
    BEA_CODES: { '423100': 0.30841268, '441000': 0.69158732 },
  },
  ['3601']: {
    label: 'General Line Grocery Wholesaling',
    BEA_CODES: { '424400': 1.0 },
  },
  ['3602']: {
    label: 'Meat, Poultry and Smallgoods Wholesaling',
    BEA_CODES: { '424400': 1.0 },
  },
  ['3603']: {
    label: 'Dairy Produce Wholesaling',
    BEA_CODES: { '424400': 1.0 },
  },
  ['3604']: {
    label: 'Fish and Seafood Wholesaling',
    BEA_CODES: { '424400': 1.0 },
  },
  ['3605']: {
    label: 'Fruit and Vegetable Wholesaling',
    BEA_CODES: { '424400': 1.0 },
  },
  ['3606']: {
    label: 'Liquor and Tobacco Product Wholesaling',
    BEA_CODES: { '424400': 1.0 },
  },
  ['3609']: {
    label: 'Other Grocery Wholesaling',
    BEA_CODES: { '424400': 1.0 },
  },
  ['3711']: {
    label: 'Textile Product Wholesaling',
    BEA_CODES: { '424A00': 1.0 },
  },
  ['3712']: {
    label: 'Clothing and Footwear Wholesaling',
    BEA_CODES: { '424A00': 1.0 },
  },
  ['3720']: {
    label: 'Pharmaceutical and Toiletry Goods Wholesaling',
    BEA_CODES: { '424200': 1.0 },
  },
  ['3731']: {
    label: 'Furniture and Floor Covering Wholesaling',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['3732']: {
    label: 'Jewellery and Watch Wholesaling',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['3733']: {
    label: 'Kitchen and Diningware Wholesaling',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['3734']: {
    label: 'Toy and Sporting Goods Wholesaling',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['3735']: {
    label: 'Book and Magazine Wholesaling',
    BEA_CODES: { '424A00': 1.0 },
  },
  ['3736']: {
    label: 'Paper Product Wholesaling',
    BEA_CODES: { '424A00': 1.0 },
  },
  ['3739']: {
    label: 'Other Goods Wholesaling n.e.c.',
    BEA_CODES: { '424A00': 1.0 },
  },
  ['3800']: {
    label: 'Commission-Based Wholesaling',
    BEA_CODES: { '425000': 1.0 },
  },
  ['3911']: { label: 'Car Retailing', BEA_CODES: { '441000': 1.0 } },
  ['3912']: { label: 'Motorcycle Retailing', BEA_CODES: { '441000': 1.0 } },
  ['3913']: {
    label: 'Trailer and Other Motor Vehicle Retailing',
    BEA_CODES: { '441000': 1.0 },
  },
  ['3921']: {
    label: 'Motor Vehicle Parts Retailing',
    BEA_CODES: { '441000': 1.0 },
  },
  ['3922']: { label: 'Tyre Retailing', BEA_CODES: { '441000': 1.0 } },
  ['4000']: { label: 'Fuel Retailing', BEA_CODES: { '447000': 1.0 } },
  ['4110']: {
    label: 'Supermarket and Grocery Stores',
    BEA_CODES: { '445000': 1.0 },
  },
  ['4121']: {
    label: 'Fresh Meat, Fish and Poultry Retailing',
    BEA_CODES: { '445000': 1.0 },
  },
  ['4122']: {
    label: 'Fruit and Vegetable Retailing',
    BEA_CODES: { '445000': 1.0 },
  },
  ['4123']: { label: 'Liquor Retailing', BEA_CODES: { '445000': 1.0 } },
  ['4129']: {
    label: 'Other Specialised Food Retailing',
    BEA_CODES: { '445000': 1.0 },
  },
  ['4211']: { label: 'Furniture Retailing', BEA_CODES: { '4B0000': 1.0 } },
  ['4212']: {
    label: 'Floor Coverings Retailing',
    BEA_CODES: { '444000': 1.0 },
  },
  ['4213']: { label: 'Houseware Retailing', BEA_CODES: { '4B0000': 1.0 } },
  ['4214']: {
    label: 'Manchester and Other Textile Goods Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4221']: {
    label: 'Electrical, Electronic and Gas Appliance Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4222']: {
    label: 'Computer and Computer Peripheral Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4229']: {
    label: 'Other Electrical and Electronic Goods Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4231']: {
    label: 'Hardware and Building Supplies Retailing',
    BEA_CODES: { '444000': 1.0 },
  },
  ['4232']: {
    label: 'Garden Supplies Retailing',
    BEA_CODES: { '444000': 1.0 },
  },
  ['4241']: {
    label: 'Sport and Camping Equipment Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4242']: {
    label: 'Entertainment Media Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4243']: { label: 'Toy and Game Retailing', BEA_CODES: { '4B0000': 1.0 } },
  ['4244']: {
    label: 'Newspaper and Book Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4245']: {
    label: 'Marine Equipment Retailing',
    BEA_CODES: { '423A00': 1.0 },
  },
  ['4251']: { label: 'Clothing Retailing', BEA_CODES: { '448000': 1.0 } },
  ['4252']: { label: 'Footwear Retailing', BEA_CODES: { '448000': 1.0 } },
  ['4253']: {
    label: 'Watch and Jewellery Retailing',
    BEA_CODES: { '448000': 0.37593967, '4B0000': 0.62406033 },
  },
  ['4259']: {
    label: 'Other Personal Accessory Retailing',
    BEA_CODES: { '448000': 1.0 },
  },
  ['4260']: { label: 'Department Stores', BEA_CODES: { '452000': 1.0 } },
  ['4271']: {
    label: 'Pharmaceutical, Cosmetic and Toiletry Goods Retailing',
    BEA_CODES: { '446000': 1.0 },
  },
  ['4272']: {
    label: 'Stationery Goods Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4273']: {
    label: 'Antique and Used Goods Retailing',
    BEA_CODES: { '4B0000': 1.0 },
  },
  ['4274']: { label: 'Flower Retailing', BEA_CODES: { '4B0000': 1.0 } },
  ['4279']: {
    label: 'Other Store-Based Retailing n.e.c.',
    BEA_CODES: { '452000': 1.0 },
  },
  ['4310']: { label: 'Non-Store Retailing', BEA_CODES: { '454000': 1.0 } },
  ['4320']: {
    label: 'Retail Commission-Based Buying and/or Selling',
    BEA_CODES: { '425000': 1.0 },
  },
  ['4400']: { label: 'Accommodation', BEA_CODES: { '721000': 1.0 } },
  ['4511']: { label: 'Cafes and Restaurants', BEA_CODES: { '722110': 1.0 } },
  ['4512']: { label: 'Takeaway Food Services', BEA_CODES: { '722211': 1.0 } },
  ['4513']: { label: 'Catering Services', BEA_CODES: { '722A00': 1.0 } },
  ['4520']: { label: 'Pubs, Taverns and Bars', BEA_CODES: { '722A00': 1.0 } },
  ['4530']: { label: 'Clubs (Hospitality)', BEA_CODES: { '722A00': 1.0 } },
  ['4610']: { label: 'Road Freight Transport', BEA_CODES: { '484000': 1.0 } },
  ['4621']: {
    label: 'Interurban and Rural Bus Transport',
    BEA_CODES: { '485000': 1.0 },
  },
  ['4622']: {
    label: 'Urban Bus Transport (Including Tramway)',
    BEA_CODES: { '485000': 1.0 },
  },
  ['4623']: {
    label: 'Taxi and Other Road Transport',
    BEA_CODES: { '485000': 1.0 },
  },
  ['4710']: { label: 'Rail Freight Transport', BEA_CODES: { '482000': 1.0 } },
  ['4720']: { label: 'Rail Passenger Transport', BEA_CODES: { '482000': 1.0 } },
  ['4810']: { label: 'Water Freight Transport', BEA_CODES: { '483000': 1.0 } },
  ['4820']: {
    label: 'Water Passenger Transport',
    BEA_CODES: { '483000': 1.0 },
  },
  ['4900']: { label: 'Air and Space Transport', BEA_CODES: { '481000': 1.0 } },
  ['5010']: {
    label: 'Scenic and Sightseeing Transport',
    BEA_CODES: { '48A000': 1.0 },
  },
  ['5021']: { label: 'Pipeline Transport', BEA_CODES: { '486000': 1.0 } },
  ['5029']: { label: 'Other Transport n.e.c.', BEA_CODES: { '485000': 1.0 } },
  ['5101']: { label: 'Postal Services', BEA_CODES: { '491000': 1.0 } },
  ['5102']: {
    label: 'Courier Pick-up and Delivery Services',
    BEA_CODES: { '492000': 1.0 },
  },
  ['5211']: { label: 'Stevedoring Services', BEA_CODES: { '48A000': 1.0 } },
  ['5212']: {
    label: 'Port and Water Transport Terminal Operations',
    BEA_CODES: { '48A000': 1.0 },
  },
  ['5219']: {
    label: 'Other Water Transport Support Services',
    BEA_CODES: { '48A000': 1.0 },
  },
  ['5220']: {
    label: 'Airport Operations and Other Air Transport Support Services',
    BEA_CODES: { '48A000': 1.0 },
  },
  ['5291']: { label: 'Customs Agency Services', BEA_CODES: { '48A000': 1.0 } },
  ['5292']: {
    label: 'Freight Forwarding Services',
    BEA_CODES: { '48A000': 1.0 },
  },
  ['5299']: {
    label: 'Other Transport Support Services n.e.c.',
    BEA_CODES: { '48A000': 1.0 },
  },
  ['5301']: { label: 'Grain Storage Services', BEA_CODES: { '493000': 1.0 } },
  ['5309']: {
    label: 'Other Warehousing and Storage Services',
    BEA_CODES: { '493000': 1.0 },
  },
  ['5411']: { label: 'Newspaper Publishing', BEA_CODES: { '511110': 1.0 } },
  ['5412']: {
    label: 'Magazine and Other Periodical Publishing',
    BEA_CODES: { '511120': 1.0 },
  },
  ['5413']: { label: 'Book Publishing', BEA_CODES: { '511130': 1.0 } },
  ['5414']: {
    label: 'Directory and Mailing List Publishing',
    BEA_CODES: { '5111A0': 1.0 },
  },
  ['5419']: {
    label: 'Other Publishing (except Software, Music and Internet)',
    BEA_CODES: { '5111A0': 1.0 },
  },
  ['5420']: { label: 'Software Publishing', BEA_CODES: { '511200': 1.0 } },
  ['5511']: {
    label: 'Motion Picture and Video Production',
    BEA_CODES: { '512100': 1.0 },
  },
  ['5512']: {
    label: 'Motion Picture and Video Distribution',
    BEA_CODES: { '512100': 1.0 },
  },
  ['5513']: {
    label: 'Motion Picture Exhibition',
    BEA_CODES: { '512100': 1.0 },
  },
  ['5514']: {
    label:
      'Post-production Services and Other Motion Picture and Video Activities',
    BEA_CODES: { '512100': 1.0 },
  },
  ['5521']: { label: 'Music Publishing', BEA_CODES: { '512200': 1.0 } },
  ['5522']: {
    label: 'Music and Other Sound Recording Activities',
    BEA_CODES: { '512200': 1.0 },
  },
  ['5610']: { label: 'Radio Broadcasting', BEA_CODES: { '515100': 1.0 } },
  ['5621']: {
    label: 'Free-to-Air Television Broadcasting',
    BEA_CODES: { '515100': 1.0 },
  },
  ['5622']: {
    label: 'Cable and Other Subscription Broadcasting',
    BEA_CODES: { '515200': 1.0 },
  },
  ['5700']: {
    label: 'Internet Publishing and Broadcasting',
    BEA_CODES: { '519130': 1.0 },
  },
  ['5801']: {
    label: 'Wired Telecommunications Network Operation',
    BEA_CODES: { '517110': 1.0 },
  },
  ['5802']: {
    label: 'Other Telecommunications Network Operation',
    BEA_CODES: { '517210': 1.0 },
  },
  ['5809']: {
    label: 'Other Telecommunications Services',
    BEA_CODES: { '517A00': 1.0 },
  },
  ['5910']: {
    label: 'Internet Service Providers and Web Search Portals',
    BEA_CODES: { '519130': 1.0 },
  },
  ['5921']: {
    label: 'Data Processing and Web Hosting Services',
    BEA_CODES: { '518200': 1.0 },
  },
  ['5922']: {
    label: 'Electronic Information Storage Services',
    BEA_CODES: { '54151A': 1.0 },
  },
  ['6010']: { label: 'Libraries and Archives', BEA_CODES: { '5191A0': 1.0 } },
  ['6020']: {
    label: 'Other Information Services',
    BEA_CODES: { '5191A0': 1.0 },
  },
  ['6210']: { label: 'Central Banking', BEA_CODES: { '52A000': 1.0 } },
  ['6221']: { label: 'Banking', BEA_CODES: { '52A000': 1.0 } },
  ['6222']: {
    label: 'Building Society Operation',
    BEA_CODES: { '52A000': 1.0 },
  },
  ['6223']: { label: 'Credit Union Operation', BEA_CODES: { '52A000': 1.0 } },
  ['6229']: {
    label: 'Other Depository Financial Intermediation',
    BEA_CODES: { '52A000': 1.0 },
  },
  ['6230']: { label: 'Non-Depository Financing', BEA_CODES: { '522A00': 1.0 } },
  ['6240']: {
    label: 'Financial Asset Investing',
    BEA_CODES: { '523900': 1.0 },
  },
  ['6310']: { label: 'Life Insurance', BEA_CODES: { '524113': 1.0 } },
  ['6321']: { label: 'Health Insurance', BEA_CODES: { '5241XX': 1.0 } },
  ['6322']: { label: 'General Insurance', BEA_CODES: { '5241XX': 1.0 } },
  ['6330']: { label: 'Superannuation Funds', BEA_CODES: { '525000': 1.0 } },
  ['6411']: {
    label: 'Financial Asset Broking Services',
    BEA_CODES: { '523A00': 1.0 },
  },
  ['6419']: {
    label: 'Other Auxiliary Finance and Investment Services',
    BEA_CODES: { '523900': 1.0 },
  },
  ['6420']: {
    label: 'Auxiliary Insurance Services',
    BEA_CODES: { '524200': 1.0 },
  },
  ['6611']: {
    label: 'Passenger Car Rental and Hiring',
    BEA_CODES: { '532100': 1.0 },
  },
  ['6619']: {
    label: 'Other Motor Vehicle and Transport Equipment Rental and Hiring',
    BEA_CODES: { '532100': 1.0 },
  },
  ['6620']: {
    label: 'Farm Animal and Bloodstock Leasing',
    BEA_CODES: { '532A00': 1.0 },
  },
  ['6631']: {
    label: 'Heavy Machinery and Scaffolding Rental and Hiring',
    BEA_CODES: { '532400': 1.0 },
  },
  ['6632']: {
    label: 'Video and Other Electronic Media Rental and Hiring',
    BEA_CODES: { '532A00': 1.0 },
  },
  ['6639']: {
    label: 'Other Goods and Equipment Rental and Hiring n.e.c.',
    BEA_CODES: { '532A00': 1.0 },
  },
  ['6640']: {
    label: 'Non-Financial Intangible Assets (Except Copyrights) Leasing',
    BEA_CODES: { '533000': 1.0 },
  },
  ['6711']: {
    label: 'Residential Property Operators',
    BEA_CODES: { '531HSO': 0.76857545, '531HST': 0.23142455 },
  },
  ['6712']: {
    label: 'Non-Residential Property Operators',
    BEA_CODES: { '531ORE': 1.0 },
  },
  ['6720']: { label: 'Real Estate Services', BEA_CODES: { '531ORE': 1.0 } },
  ['6910']: {
    label: 'Scientific Research Services',
    BEA_CODES: { '541700': 1.0 },
  },
  ['6921']: { label: 'Architectural Services', BEA_CODES: { '541300': 1.0 } },
  ['6922']: {
    label: 'Surveying and Mapping Services',
    BEA_CODES: { '541300': 1.0 },
  },
  ['6923']: {
    label: 'Engineering Design and Engineering Consulting Services',
    BEA_CODES: { '541300': 1.0 },
  },
  ['6924']: {
    label: 'Other Specialised Design Services',
    BEA_CODES: { '541800': 1.0 },
  },
  ['6925']: {
    label: 'Scientific Testing and Analysis Services',
    BEA_CODES: { '541300': 1.0 },
  },
  ['6931']: { label: 'Legal Services', BEA_CODES: { '541100': 1.0 } },
  ['6932']: { label: 'Accounting Services', BEA_CODES: { '541200': 1.0 } },
  ['6940']: { label: 'Advertising Services', BEA_CODES: { '541800': 1.0 } },
  ['6950']: {
    label: 'Market Research and Statistical Services',
    BEA_CODES: { '5419A0': 1.0 },
  },
  ['6961']: {
    label: 'Corporate Head Office Management Services',
    BEA_CODES: { '550000': 1.0 },
  },
  ['6962']: {
    label: 'Management Advice and Related Consulting Services',
    BEA_CODES: {
      '541610': 0.15840337,
      '5416A0': 0.0450571,
      '541700': 0.48058514,
      '541800': 0.3159544,
    },
  },
  ['6970']: { label: 'Veterinary Services', BEA_CODES: { '541940': 1.0 } },
  ['6991']: {
    label: 'Professional Photographic Services',
    BEA_CODES: { '541920': 1.0 },
  },
  ['6999']: {
    label: 'Other Professional, Scientific and Technical Services n.e.c.',
    BEA_CODES: { '5419A0': 1.0 },
  },
  ['7000']: {
    label: 'Computer System Design and Related Services',
    BEA_CODES: { '541512': 1.0 },
  },
  ['7211']: {
    label: 'Employment Placement and Recruitment Services',
    BEA_CODES: { '5419A0': 1.0 },
  },
  ['7212']: { label: 'Labour Supply Services', BEA_CODES: { '561300': 1.0 } },
  ['7220']: {
    label: 'Travel Agency and Tour Arrangement Services',
    BEA_CODES: { '561500': 1.0 },
  },
  ['7291']: {
    label: 'Office Administrative Services',
    BEA_CODES: { '561100': 1.0 },
  },
  ['7292']: {
    label: 'Document Preparation Services',
    BEA_CODES: { '561400': 1.0 },
  },
  ['7293']: {
    label: 'Credit Reporting and Debt Collection Services',
    BEA_CODES: { '561400': 1.0 },
  },
  ['7294']: { label: 'Call Centre Operation', BEA_CODES: { '561400': 1.0 } },
  ['7299']: {
    label: 'Other Administrative Services n.e.c.',
    BEA_CODES: { '561900': 1.0 },
  },
  ['7311']: {
    label: 'Building and Other Industrial Cleaning Services',
    BEA_CODES: { '561700': 1.0 },
  },
  ['7312']: {
    label: 'Building Pest Control Services',
    BEA_CODES: { '561700': 1.0 },
  },
  ['7313']: { label: 'Gardening Services', BEA_CODES: { '561700': 1.0 } },
  ['7320']: { label: 'Packaging Services', BEA_CODES: { '561900': 1.0 } },
  ['7510']: {
    label: 'Central Government Administration',
    BEA_CODES: { S00600: 1.0 },
  },
  ['7520']: {
    label: 'State Government Administration',
    BEA_CODES: { GSLGO: 1.0 },
  },
  ['7530']: {
    label: 'Local Government Administration',
    BEA_CODES: { GSLGO: 1.0 },
  },
  ['7540']: {
    label: 'Justice',
    BEA_CODES: { GSLGO: 0.6913508, S00600: 0.3086492 },
  },
  ['7551']: {
    label: 'Domestic Government Representation',
    BEA_CODES: { S00600: 1.0 },
  },
  ['7552']: {
    label: 'Foreign Government Representation',
    BEA_CODES: { S00600: 1.0 },
  },
  ['7600']: { label: 'Defence', BEA_CODES: { S00500: 1.0 } },
  ['7711']: {
    label: 'Police Services',
    BEA_CODES: { GSLGO: 0.6913508, S00600: 0.3086492 },
  },
  ['7712']: {
    label: 'Investigation and Security Services',
    BEA_CODES: { '561600': 1.0 },
  },
  ['7713']: {
    label: 'Fire Protection and Other Emergency Services',
    BEA_CODES: { S00203: 1.0 },
  },
  ['7714']: {
    label: 'Correctional and Detention Services',
    BEA_CODES: { GSLGO: 1.0 },
  },
  ['7719']: {
    label: 'Other Public Order and Safety Services',
    BEA_CODES: { GSLGO: 0.6416503, S00203: 0.07188898, S00600: 0.28646073 },
  },
  ['7720']: {
    label: 'Regulatory Services',
    BEA_CODES: { GSLGO: 0.6913508, S00600: 0.3086492 },
  },
  ['8010']: { label: 'Preschool Education', BEA_CODES: { '611B00': 1.0 } },
  ['8021']: { label: 'Primary Education', BEA_CODES: { '611100': 1.0 } },
  ['8022']: { label: 'Secondary Education', BEA_CODES: { '611100': 1.0 } },
  ['8023']: {
    label: 'Combined Primary and Secondary Education',
    BEA_CODES: { '611100': 1.0 },
  },
  ['8024']: { label: 'Special School Education', BEA_CODES: { '611B00': 1.0 } },
  ['8101']: {
    label: 'Technical and Vocational Education and Training',
    BEA_CODES: { '611B00': 1.0 },
  },
  ['8102']: { label: 'Higher Education', BEA_CODES: { '611A00': 1.0 } },
  ['8211']: {
    label: 'Sports and Physical Recreation Instruction',
    BEA_CODES: { '611B00': 1.0 },
  },
  ['8212']: { label: 'Arts Education', BEA_CODES: { '611B00': 1.0 } },
  ['8219']: {
    label: 'Adult, Community and Other Education n.e.c.',
    BEA_CODES: { '611B00': 1.0 },
  },
  ['8220']: {
    label: 'Educational Support Services',
    BEA_CODES: { '611B00': 1.0 },
  },
  ['8401']: {
    label: 'Hospitals (Except Psychiatric Hospitals)',
    BEA_CODES: { '622000': 1.0 },
  },
  ['8402']: { label: 'Psychiatric Hospitals', BEA_CODES: { '622000': 1.0 } },
  ['8511']: {
    label: 'General Practice Medical Services',
    BEA_CODES: { '621100': 1.0 },
  },
  ['8512']: {
    label: 'Specialist Medical Services',
    BEA_CODES: { '621100': 1.0 },
  },
  ['8520']: {
    label: 'Pathology and Diagnostic Imaging Services',
    BEA_CODES: { '621500': 1.0 },
  },
  ['8531']: { label: 'Dental Services', BEA_CODES: { '621200': 1.0 } },
  ['8532']: {
    label: 'Optometry and Optical Dispensing',
    BEA_CODES: { '621300': 1.0 },
  },
  ['8533']: { label: 'Physiotherapy Services', BEA_CODES: { '621300': 1.0 } },
  ['8534']: {
    label: 'Chiropractic and Osteopathic Services',
    BEA_CODES: { '621300': 1.0 },
  },
  ['8539']: {
    label: 'Other Allied Health Services',
    BEA_CODES: { '621300': 0.72989049, '621900': 0.27010951 },
  },
  ['8591']: { label: 'Ambulance Services', BEA_CODES: { '621900': 1.0 } },
  ['8599']: {
    label: 'Other Health Care Services n.e.c.',
    BEA_CODES: { '621900': 1.0 },
  },
  ['8601']: {
    label: 'Aged Care Residential Services',
    BEA_CODES: { '623A00': 1.0 },
  },
  ['8609']: {
    label: 'Other Residential Care Services',
    BEA_CODES: { '623A00': 1.0 },
  },
  ['8710']: { label: 'Child Care Services', BEA_CODES: { '624400': 1.0 } },
  ['8790']: {
    label: 'Other Social Assistance Services',
    BEA_CODES: { '624A00': 1.0 },
  },
  ['8910']: { label: 'Museum Operation', BEA_CODES: { '711100': 1.0 } },
  ['8921']: {
    label: 'Zoological and Botanical Gardens Operation',
    BEA_CODES: { '712000': 1.0 },
  },
  ['8922']: {
    label: 'Nature Reserves and Conservation Parks Operation',
    BEA_CODES: { '712000': 1.0 },
  },
  ['9001']: {
    label: 'Performing Arts Operation',
    BEA_CODES: { '711100': 1.0 },
  },
  ['9002']: {
    label: 'Creative Artists, Musicians, Writers and Performers',
    BEA_CODES: { '711500': 1.0 },
  },
  ['9003']: {
    label: 'Performing Arts Venue Operation',
    BEA_CODES: { '711A00': 1.0 },
  },
  ['9111']: {
    label: 'Health and Fitness Centres and Gymnasia Operation',
    BEA_CODES: { '713900': 1.0 },
  },
  ['9112']: {
    label: 'Sports and Physical Recreation Clubs and Sports Professionals',
    BEA_CODES: { '713900': 1.0 },
  },
  ['9113']: {
    label:
      'Sports and Physical Recreation Venues, Grounds and Facilities Operation',
    BEA_CODES: { '711200': 0.35970619, '713900': 0.64029381 },
  },
  ['9114']: {
    label: 'Sports and Physical Recreation Administrative Service',
    BEA_CODES: { '711A00': 0.28409951, '713900': 0.71590049 },
  },
  ['9121']: {
    label: 'Horse and Dog Racing Administration and Track Operation',
    BEA_CODES: { '711200': 0.35970619, '713900': 0.64029381 },
  },
  ['9129']: {
    label: 'Other Horse and Dog Racing Activities',
    BEA_CODES: { '711200': 1.0 },
  },
  ['9131']: {
    label: 'Amusement Parks and Centres Operation',
    BEA_CODES: { '713100': 1.0 },
  },
  ['9139']: {
    label: 'Amusement and Other Recreational Activities n.e.c.',
    BEA_CODES: { '713900': 1.0 },
  },
  ['9201']: { label: 'Casino Operation', BEA_CODES: { '713200': 1.0 } },
  ['9202']: { label: 'Lottery Operation', BEA_CODES: { '713200': 1.0 } },
  ['9209']: {
    label: 'Other Gambling Activities',
    BEA_CODES: { '713200': 1.0 },
  },
  ['9411']: {
    label: 'Automotive Electrical Services',
    BEA_CODES: { '811100': 1.0 },
  },
  ['9412']: {
    label: 'Automotive Body, Paint and Interior Repair',
    BEA_CODES: { '811100': 1.0 },
  },
  ['9419']: {
    label: 'Other Automotive Repair and Maintenance',
    BEA_CODES: { '811100': 1.0 },
  },
  ['9421']: {
    label: 'Domestic Appliance Repair and Maintenance',
    BEA_CODES: { '811200': 1.0 },
  },
  ['9422']: {
    label:
      'Electronic (except Domestic Appliance) and Precision Equipment Repair and Maintenance',
    BEA_CODES: { '811200': 1.0 },
  },
  ['9429']: {
    label: 'Other Machinery and Equipment Repair and Maintenance',
    BEA_CODES: { '811300': 1.0 },
  },
  ['9491']: {
    label: 'Clothing and Footwear Repair',
    BEA_CODES: { '811400': 1.0 },
  },
  ['9499']: {
    label: 'Other Repair and Maintenance n.e.c.',
    BEA_CODES: { '811400': 1.0 },
  },
  ['9511']: {
    label: 'Hairdressing and Beauty Services',
    BEA_CODES: { '812100': 1.0 },
  },
  ['9512']: {
    label: 'Diet and Weight Reduction Centre Operation',
    BEA_CODES: { '812900': 1.0 },
  },
  ['9520']: {
    label: 'Funeral, Crematorium and Cemetery Services',
    BEA_CODES: { '812200': 1.0 },
  },
  ['9531']: {
    label: 'Laundry and Dry-Cleaning Services',
    BEA_CODES: { '812300': 1.0 },
  },
  ['9532']: {
    label: 'Photographic Film Processing',
    BEA_CODES: { '541920': 1.0 },
  },
  ['9533']: { label: 'Parking Services', BEA_CODES: { '48A000': 1.0 } },
  ['9534']: {
    label: 'Brothel Keeping and Prostitution Services',
    BEA_CODES: { '812900': 1.0 },
  },
  ['9539']: {
    label: 'Other Personal Services n.e.c.',
    BEA_CODES: { '812900': 1.0 },
  },
  ['9540']: { label: 'Religious Services', BEA_CODES: { '813100': 1.0 } },
  ['9551']: {
    label: 'Business and Professional Association Services',
    BEA_CODES: { '813B00': 1.0 },
  },
  ['9552']: {
    label: 'Labour Association Services',
    BEA_CODES: { '813B00': 1.0 },
  },
  ['9559']: {
    label: 'Other Interest Group Services n.e.c.',
    BEA_CODES: { '813B00': 1.0 },
  },
  ['9601']: {
    label: 'Private Households Employing Staff',
    BEA_CODES: { '814000': 1.0 },
  },
};
